module.exports = __webpack_public_path__ + "static/technical-documentation-img-80c0a33070f98d44886f6556e9b642f3.png";